var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 9.167A1.84 1.84 0 0 0 3.667 11c0 1.008.825 1.833 1.833 1.833A1.84 1.84 0 0 0 7.334 11 1.84 1.84 0 0 0 5.5 9.166M16.5 9.167A1.84 1.84 0 0 0 14.667 11c0 1.008.825 1.833 1.833 1.833A1.84 1.84 0 0 0 18.334 11 1.84 1.84 0 0 0 16.5 9.166M11 9.167A1.84 1.84 0 0 0 9.167 11c0 1.008.825 1.833 1.833 1.833A1.84 1.84 0 0 0 12.834 11 1.84 1.84 0 0 0 11 9.166"
  })));
};
export default SvgMore;